import { forwardRef, type InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import { kopecksToRublesInput, parseRublesToKopecks } from '@/lib/moneyInput';
import styles from './MoneyInput.module.css';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  value: number;                            // копейки
  onChange: (kopecks: number) => void;
  invalid?: boolean;
}

export const MoneyInput = forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, invalid, className, ...rest }, ref) => (
    <div className={clsx(styles.wrap, invalid && styles.invalid, className)}>
      <input
        ref={ref}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={kopecksToRublesInput(value)}
        onChange={(e) => {
          const kopecks = parseRublesToKopecks(e.target.value);
          onChange(kopecks ?? 0);
        }}
        className={styles.input}
        {...rest}
      />
      <span className={styles.suffix}>₽</span>
    </div>
  ),
);
MoneyInput.displayName = 'MoneyInput';